module.exports = require("@material-ui/icons/Block");